module.exports = __webpack_public_path__ + "img/camera-web-solid.c15b91bc.svg";